import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger } from '@fluentui/react-components';

interface Props {
  open: boolean;
  onOpenChange(boolean: boolean): void
  onConfirm(): void;
}

export default function ConfirmToLeaveDialog(props: Props) {
	return (
		<Dialog
			open={props.open}
			onOpenChange={(event, data) => {
				props.onOpenChange(data.open);
			}}
		>
			<DialogSurface>
				<DialogBody>
					<DialogTitle>Discard Changes?</DialogTitle>
					<DialogContent>
            You have unsaved changes to this automation rule. If you go back now, your changes will be lost.
            Are you sure you want to leave without saving?
					</DialogContent>

					<DialogActions>
						<DialogTrigger disableButtonEnhancement>
							<Button appearance="primary">Stay on page</Button>
						</DialogTrigger>
						<Button onClick={props.onConfirm} appearance="secondary">Discard changes</Button>
					</DialogActions>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
}